export function extractErrorSentenceContext(fullText: string, errorText: string): string {
  const text = String(fullText || "")
    .replace(/\s+/g, " ")
    .trim();

  const error = String(errorText || "")
    .replace(/\s+/g, " ")
    .trim();

  if (!text) return "";
  if (!error) return "";

  // Remover marcadores artificiais que podem vir da correção IA
  const cleanedText = text
    .replace(/===\s*Section\s*A\s*===/gi, " ")
    .replace(/===\s*Section\s*B\s*===/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

  const normalizedError = error.toLowerCase();

  // Divisão em frases por pontuação francesa/geral
  const sentences =
    (cleanedText.match(/[^.!?。！？]+[.!?。！？]+|[^.!?。！？]+$/g) || []) as string[];

  const foundSentence = sentences.find((sentence) =>
    sentence.toLowerCase().includes(normalizedError)
  );

  if (foundSentence) {
    return foundSentence.trim();
  }

  // Fallback: procurar índice do erro no texto
  const index = cleanedText.toLowerCase().indexOf(normalizedError);

  if (index >= 0) {
    // procurar início da frase antes do erro
    let start = index;
    while (start > 0 && !".!?。！？".includes(cleanedText[start - 1])) {
      start--;
    }

    // procurar fim da frase depois do erro
    let end = index + error.length;
    while (end < cleanedText.length && !".!?。！？".includes(cleanedText[end])) {
      end++;
    }

    if (end < cleanedText.length) end++;

    return cleanedText.slice(start, end).trim();
  }

  // Último fallback: não retornar redação inteira.
  // Retornar vazio para evitar contexto gigante.
  return "";
}

export function limitContextSentence(text: string): string {
  const value = String(text || "").trim();
  if (value.length <= 280) return value;
  return value.slice(0, 280).trim() + "...";
}
